import { BulkActionCreateEvent } from './bulk-actions/BulkActionCreate.event.js';
import { BulkActionLogCreateEvent } from './bulk-actions/BulkActionLogCreate.event.js';
import { BulkActionUpdateEvent } from './bulk-actions/BulkActionUpdate.event.js';
import { CardArchivedEvent } from './cards/CardArchived.event.js';
import { CardCommentCreateEvent } from './cards/CardCommentCreate.event.js';
import { CardCommentUpdateEvent } from './cards/CardCommentUpdate.event.js';
import { CardCreateEvent } from './cards/CardCreate.event.js';
import { CardFieldAnsweredEvent } from './cards/CardFieldAnswered.event.js';
import { CardLogCreateEvent } from './cards/CardLogCreate.event.js';
import { CardMoveEvent } from './cards/CardMove.event.js';
import { CardUnarchivedEvent } from './cards/CardUnarchived.event.js';
import { CardUpdateEvent } from './cards/CardUpdate.event.js';
import { ClientAuthEvent } from './client/ClientAuth.event.js';
import { ClientHeartbeatEvent } from './client/ClientHeartbeat.event.js';
import { ClientHelloEvent } from './client/ClientHello.event.js';
import { ClientSubscribeEvent } from './client/ClientSubscribe.event.js';
import { ClientUnsubscribeEvent } from './client/ClientUnsubscribe.event.js';
import { ExportCreateEvent } from './exports/ExportCreate.event.js';
import { ExportLogCreateEvent } from './exports/ExportLogCreate.event.js';
import { ExportUpdateEvent } from './exports/ExportUpdate.event.js';
import { MySpaceMyCardsCreateEvent } from './my-space/my-cards/MySpaceMyCardsCreate.event.js';
import { MySpaceMyCardsRefreshEvent } from './my-space/my-cards/MySpaceMyCardsRefresh.event.js';
import { MySpaceMyCardsUpdateEvent } from './my-space/my-cards/MySpaceMyCardsUpdate.event.js';
import { MySpaceMyReviewsCreateEvent } from './my-space/my-reviews/MySpaceMyReviewsCreate.event.js';
import { MySpaceMyReviewsRefreshEvent } from './my-space/my-reviews/MySpaceMyReviewsRefresh.event.js';
import { MySpaceMyReviewsUpdateEvent } from './my-space/my-reviews/MySpaceMyReviewsUpdate.event.js';
import { MySpaceMySolicitationsCreateEvent } from './my-space/my-solicitations/MySpaceMySolicitationsCreate.event.js';
import { MySpaceMySolicitationsRefreshEvent } from './my-space/my-solicitations/MySpaceMySolicitationsRefresh.event.js';
import { MySpaceMySolicitationsUpdateEvent } from './my-space/my-solicitations/MySpaceMySolicitationsUpdate.event.js';
import { MySpaceMyTasksCreateEvent } from './my-space/my-tasks/MySpaceMyTasksCreate.event.js';
import { MySpaceMyTasksRefreshEvent } from './my-space/my-tasks/MySpaceMyTasksRefresh.event.js';
import { MySpaceMyTasksUpdateEvent } from './my-space/my-tasks/MySpaceMyTasksUpdate.event.js';
import { NotificationCreateEvent } from './notifications/NotificationCreate.event.js';
import { SystemAckEvent } from './system/SystemAck.event.js';
import { SystemCloseEvent } from './system/SystemClose.event.js';
import { SystemConnectEvent } from './system/SystemConnect.event.js';
import { SystemErrorEvent } from './system/SystemError.event.js';
import { SystemHeartbeatEvent } from './system/SystemHeartbeat.event.js';
import { SystemHelloEvent } from './system/SystemHello.event.js';

export const REALTIME_EVENT_MAP = {
  [BulkActionCreateEvent.type]: BulkActionCreateEvent,
  [BulkActionUpdateEvent.type]: BulkActionUpdateEvent,
  [BulkActionLogCreateEvent.type]: BulkActionLogCreateEvent,

  [CardMoveEvent.type]: CardMoveEvent,
  [CardCreateEvent.type]: CardCreateEvent,
  [CardUpdateEvent.type]: CardUpdateEvent,
  [CardArchivedEvent.type]: CardArchivedEvent,
  [CardUnarchivedEvent.type]: CardUnarchivedEvent,
  [CardLogCreateEvent.type]: CardLogCreateEvent,
  [CardFieldAnsweredEvent.type]: CardFieldAnsweredEvent,
  [CardCommentCreateEvent.type]: CardCommentCreateEvent,
  [CardCommentUpdateEvent.type]: CardCommentUpdateEvent,

  [ClientHeartbeatEvent.type]: ClientHeartbeatEvent,
  [ClientHelloEvent.type]: ClientHelloEvent,
  [ClientSubscribeEvent.type]: ClientSubscribeEvent,
  [ClientUnsubscribeEvent.type]: ClientUnsubscribeEvent,
  [ClientAuthEvent.type]: ClientAuthEvent,

  [ExportCreateEvent.type]: ExportCreateEvent,
  [ExportLogCreateEvent.type]: ExportLogCreateEvent,
  [ExportUpdateEvent.type]: ExportUpdateEvent,

  [SystemAckEvent.type]: SystemAckEvent,
  [SystemHeartbeatEvent.type]: SystemHeartbeatEvent,
  [SystemCloseEvent.type]: SystemCloseEvent,
  [SystemErrorEvent.type]: SystemErrorEvent,
  [SystemHelloEvent.type]: SystemHelloEvent,
  [SystemConnectEvent.type]: SystemConnectEvent,

  [NotificationCreateEvent.type]: NotificationCreateEvent,

  [MySpaceMyCardsCreateEvent.type]: MySpaceMyCardsCreateEvent,
  [MySpaceMyCardsRefreshEvent.type]: MySpaceMyCardsRefreshEvent,
  [MySpaceMyCardsUpdateEvent.type]: MySpaceMyCardsUpdateEvent,

  [MySpaceMyReviewsCreateEvent.type]: MySpaceMyReviewsCreateEvent,
  [MySpaceMyReviewsRefreshEvent.type]: MySpaceMyReviewsRefreshEvent,
  [MySpaceMyReviewsUpdateEvent.type]: MySpaceMyReviewsUpdateEvent,

  [MySpaceMySolicitationsCreateEvent.type]: MySpaceMySolicitationsCreateEvent,
  [MySpaceMySolicitationsRefreshEvent.type]: MySpaceMySolicitationsRefreshEvent,
  [MySpaceMySolicitationsUpdateEvent.type]: MySpaceMySolicitationsUpdateEvent,

  [MySpaceMyTasksCreateEvent.type]: MySpaceMyTasksCreateEvent,
  [MySpaceMyTasksRefreshEvent.type]: MySpaceMyTasksRefreshEvent,
  [MySpaceMyTasksUpdateEvent.type]: MySpaceMyTasksUpdateEvent,
} as const;
